import PageHeader from "@/components/app/PageHeader";
import ActivityFeed from "@/components/app/ActivityFeed";
import { Activity } from "lucide-react";

const ActivityPage = () => (
  <div>
    <PageHeader
      eyebrow="Workspace"
      title="Activity feed"
      description="Recent actions across all your projects."
    />
    <div className="px-5 sm:px-8 lg:px-12 py-6">
      <div className="border border-[#1F2937] bg-[#0D1117]">
        <div className="px-4 py-3 border-b border-[#1F2937] bg-[#111827] flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] text-[#6B7280]">
          <Activity className="w-3.5 h-3.5" /> Recent events
        </div>
        <ActivityFeed limit={100} />
      </div>
    </div>
  </div>
);

export default ActivityPage;
